module.exports = __webpack_public_path__ + "promotion-banner-desktop-osm.3ca6632e94bf666acb1cbef720e21f46.png";